<div>
  <div class="container" >
    <div class="height6"></div>
    <div  class="ion-align-self-center height14">
      <!--Image Section-->
      <p class="emoji-gift-cone">🎉</p>
    </div>
    <div class="height15">
      <h2 class="text-sent">{{'password-text.text' | translate}}</h2>
      <p class="password-sent-confirmation">
        {{'password-text.Please' | translate}}
      </p>
    </div>
    <div  class="back-login height20">
      <ion-button expand="block" color="medium" class="capsule-btn common-margin" type="submit" (click)="backToLogin()">
        {{'password-text.login' | translate}}
      </ion-button>

    </div>
    <div class="height20">
      <!--Empty space Below-->
    </div>
  </div>
</div>